import { render, staticRenderFns } from "./priceRemove.vue?vue&type=template&id=ea108cee&scoped=true"
import script from "./priceRemove.vue?vue&type=script&lang=js"
export * from "./priceRemove.vue?vue&type=script&lang=js"
import style0 from "./priceRemove.vue?vue&type=style&index=0&id=ea108cee&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea108cee",
  null
  
)

export default component.exports